import { render, staticRenderFns } from "./BaseMultiSelect.vue?vue&type=template&id=fa3c852c&scoped=true&"
import script from "./BaseMultiSelect.vue?vue&type=script&lang=ts&"
export * from "./BaseMultiSelect.vue?vue&type=script&lang=ts&"
import style0 from "./BaseMultiSelect.vue?vue&type=style&index=0&id=fa3c852c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3c852c",
  null
  
)

export default component.exports